module.exports = __webpack_public_path__ + "assets/img/icon-home-selected1.227ebea1.png";